import {
  SET_CASH_RECEIPT,
  SET_SPECIFIC_CASH_RECEIPT,
  SET_BALANCE,
  SET_PENDING_SALES,
} from "../Types/CashReceiptTypes";

const initialState = {
  allCashReceipt: [{ id: 1 }],
  specificCashReceipt: {},
  pendingSales: [],
  customerBalance: {},
};

const CashReceiptReducer = (state = initialState, action) => {
  if (action.type === SET_CASH_RECEIPT) {
    return { ...state, allCashReceipt: action.payLoad };
  } else if (action.type === SET_SPECIFIC_CASH_RECEIPT) {
    return { ...state, specificCashReceipt: action.payLoad };
  } else if (action.type === SET_BALANCE) {
    return { ...state, customerBalance: action.payLoad };
  } else if (action.type === SET_PENDING_SALES) {
    return { ...state, pendingSales: action.payLoad };
  } else {
    return state;
  }
};

export default CashReceiptReducer;
